import { formatDistanceToNow } from 'date-fns';
import { enUS, uk } from 'date-fns/locale';
import i18n from './i18n';

function locale() {
  return i18n.language.startsWith('uk') ? uk : enUS;
}

function activeLocale(): string {
  return i18n.language.startsWith('uk') ? 'uk' : 'en';
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return new Intl.DateTimeFormat(activeLocale(), {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(d);
}

export function formatDistance(iso: string | null | undefined): string {
  if (!iso) return '—';
  return formatDistanceToNow(new Date(iso), { addSuffix: true, locale: locale() });
}

export function formatDuration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) return '—';
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return s ? `${m}m ${s}s` : `${m}m`;
}
